var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Modal from 'react-modal';
import { useOpts } from './context';
import modalOverlayStyle from './consts/styles';
import { getModalMountNode } from './utils';
import { useAppSelector } from './state';
import { selectFeatureFlags, selectLinkParams, } from './state/slices/slice-link-params';
import { checkHackyWorkspace } from './utils/hacky-workspace-customizations';
export var DEFAULT_THEME = '#1170FF';
var getContentStyleOverrides = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.deltaX, deltaX = _a === void 0 ? '0px' : _a, _b = options.deltaY, deltaY = _b === void 0 ? '0px' : _b, height = options.height, _c = options.width, width = _c === void 0 ? '432px' : _c, border = options.border;
    return {
        transform: "translate(calc(-50% + ".concat(deltaX, "), calc(-50% + ").concat(deltaY, "))"),
        // Note: we're relying on the SCSS styles at the `max-width: 475px` breakpoint to override these styles when the
        // screen is small. However, if for some reason that doesn't work (e.g. on a browser/device we never tested), not
        // setting top/left here would result in the above transformation shifting the modal offscreen.
        top: '50%',
        left: '50%',
        maxWidth: width,
        minHeight: height || '640px',
        maxHeight: height || '680px',
        border: border || 'none',
    };
};
var getOverlayStyleOverrides = function (options) {
    if (options === void 0) { options = {}; }
    var backgroundColor = options.backgroundColor;
    // return default modalOverlayStyle but with the backgroundColor overridden if it's provided
    return __assign(__assign({}, modalOverlayStyle), (backgroundColor && { backgroundColor: backgroundColor }));
};
var ModalWrapper = function (_a) {
    var _b, _c;
    var children = _a.children;
    var open = useOpts().open;
    var linkParams = useAppSelector(selectLinkParams);
    var featureFlags = useAppSelector(selectFeatureFlags);
    var border = 'none';
    // TODO: This is not great, I'd like to put this border styling param
    // into the modalStyling object, but it's several library updates.
    // See https://pinwheel.atlassian.net/browse/CORE-1923
    if (checkHackyWorkspace('TurboTax', (_b = linkParams === null || linkParams === void 0 ? void 0 : linkParams.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.workspaceName) ||
        checkHackyWorkspace('TurboTax (NativeLink Test)', (_c = linkParams === null || linkParams === void 0 ? void 0 : linkParams.linkTokenPayload) === null || _c === void 0 ? void 0 : _c.workspaceName)) {
        // give the border the color TurboTax wanted
        border = "1px solid #C3CED5";
    }
    var contentStyleOverrides = __assign(__assign({}, getContentStyleOverrides(linkParams === null || linkParams === void 0 ? void 0 : linkParams.modalStyling)), { border: border });
    var additionalParams = process.env.STORYBOOK
        ? {
            parentSelector: function () {
                return document.getElementById('storybook-root');
            },
        }
        : {};
    return (React.createElement(Modal, __assign({ appElement: getModalMountNode(), "data-testid": "modal", isOpen: !!open, className: "modal-content", style: {
            overlay: featureFlags.modalStylingEnabled
                ? getOverlayStyleOverrides(linkParams === null || linkParams === void 0 ? void 0 : linkParams.overlayStyling)
                : modalOverlayStyle,
            content: __assign({}, (featureFlags.modalStylingEnabled && contentStyleOverrides)),
        }, ariaHideApp: false }, additionalParams), children));
};
export default ModalWrapper;
